<div class="row">
    <div class="col-sm-12">
        <ccl-route-tabs>
            <ccl-route-tab tabTitle="Additional Settings" route="additional-setting"></ccl-route-tab>
            <ccl-route-tab tabTitle="Edit Label(s)" route="edit-label"></ccl-route-tab>
            <ccl-route-tab tabTitle="Edit Buttons & Icons" route="button-config"></ccl-route-tab>
            <ccl-route-tab tabTitle="Add To Calendar" [hidden]="!buttonConfig.enableAddToCalendarButton" route="add-to-calendar-config"></ccl-route-tab>
            <ccl-route-tab tabTitle="Rules & Validations" route="rules-validation-config"></ccl-route-tab>
        </ccl-route-tabs>
        <ccl-section-wrapper>
            <ccl-content-section>
                <router-outlet></router-outlet>
            </ccl-content-section>
        </ccl-section-wrapper>
    </div>
</div>
